import { render, staticRenderFns } from "./payChannelInfoModal.vue?vue&type=template&id=8a2b051e&scoped=true&"
import script from "./payChannelInfoModal.vue?vue&type=script&lang=js&"
export * from "./payChannelInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2b051e",
  null
  
)

export default component.exports